import {
  ADD_TASK_LOCATION,
  CREATE_TASK,
  CREATE_MAX_TASK_DURATION,
  CREATE_MASTER_TASK,
  CREATE_LINK_TASK,
  DELETE_TASK,
  DUPLICATE_TASK,
  EDIT_TASK,
  GET_TASKS_LIST,
  GET_TASK_DETAILS,
  GET_TASK_LOCATIONS,
  GET_TASK_TYPE,
  GET_MASTER_TASK,
  GET_NEW_TASK,
  GET_MAX_TASK_DURATION,
  UPDATE_TASK_STATUS,
  CLEAR_TASK_STATE,
  CLEAR_LINK_TASK_STATE,
  CLEAR_NEW_TASK_STATE,
  CLEAR_MASTER_TASK_STATE,
  CLEAR_MAX_TASK_TIME,
  UPDATE_TASK_LOCATION,
  GET_LOCATION_TYPE_LIST,
  ARCHIVE_TASK_LOCATION,
  UPDATE_MASTER_TASK,
  ARCHIVE_MASTER_TASK,
  UNARCHIVE_MASTER_TASK,
  EXPORT_TASKS,
} from '../../modules/constants';

export function getTasksList(value) {
  return {
    type: GET_TASKS_LIST,
    payload: value,
  };
}

export function createTask(value) {
  return {
    type: CREATE_TASK,
    payload: value,
  };
}

export function createMasterTask(value) {
  return {
    type: CREATE_MASTER_TASK,
    payload: value,
  };
}

export function updateMasterTask(value) {
  return {
    type: UPDATE_MASTER_TASK,
    payload: value,
  };
}

export function archiveMasterTask(value) {
  return {
    type: ARCHIVE_MASTER_TASK,
    payload: value,
  };
}

export function unarchiveMasterTask(value) {
  return {
    type: UNARCHIVE_MASTER_TASK,
    payload: value,
  };
}
export function createLinkTask(value) {
  return {
    type: CREATE_LINK_TASK,
    payload: value,
  };
}

export function createMaxTaskDuration(value) {
  return {
    type: CREATE_MAX_TASK_DURATION,
    payload: value,
  };
}

export function getTaskDetails(value) {
  return {
    type: GET_TASK_DETAILS,
    payload: value,
  };
}

export function editTask(value) {
  return {
    type: EDIT_TASK,
    payload: value,
  };
}

export function duplicateTask(value) {
  return {
    type: DUPLICATE_TASK,
    payload: value,
  };
}

export function deleteTask(value) {
  return {
    type: DELETE_TASK,
    payload: value,
  };
}

export function getTaskLocation(value) {
  return {
    type: GET_TASK_LOCATIONS,
    payload: value,
  };
}

export function updateTaskApproval(value) {
  return {
    type: UPDATE_TASK_STATUS,
    payload: value,
  };
}

export function addTaskLocation(value) {
  return {
    type: ADD_TASK_LOCATION,
    payload: value,
  };
}

export function getTaskType(value) {
  return {
    type: GET_TASK_TYPE,
    payload: value,
  };
}

export function getMasterTask(value) {
  return {
    type: GET_MASTER_TASK,
    payload: value,
  };
}

export function getNewTasks(value) {
  return {
    type: GET_NEW_TASK,
    payload: value,
  };
}

export function clearTaskState() {
  return {
    type: CLEAR_TASK_STATE,
  };
}

export function clearLinkTaskState() {
  return {
    type: CLEAR_LINK_TASK_STATE,
  };
}

export function clearNewTaskState() {
  return {
    type: CLEAR_NEW_TASK_STATE,
  };
}

export function clearMaxTaskTimeState() {
  return {
    type: CLEAR_MAX_TASK_TIME,
  };
}

export function clearMasterTaskState() {
  return {
    type: CLEAR_MASTER_TASK_STATE,
  };
}

export function updateTaskLocation(value) {
  return {
    type: UPDATE_TASK_LOCATION,
    payload: value,
  };
}

export function getLocationTypeList(value) {
  return {
    type: GET_LOCATION_TYPE_LIST,
    payload: value,
  };
}

export const archiveTaskLocation = (payload) => ({
  type: ARCHIVE_TASK_LOCATION,
  payload,
});

export function getMaxTaskDuration() {
  return {
    type: GET_MAX_TASK_DURATION,
  };
}

export function exportTasks(value) {
  return {
    type: EXPORT_TASKS,
    payload: value,
  };
}
